/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LeadClosedReasonEnum {
    NoCommunicationFromTheBeginning = 'NO_COMMUNICATION_FROM_THE_BEGINNING',
    NoCommunicationAfterTheOffer = 'NO_COMMUNICATION_AFTER_THE_OFFER',
    InvalidContactAnotherPerson = 'INVALID_CONTACT_ANOTHER_PERSON',
    InvalidContactWrongNumber = 'INVALID_CONTACT_WRONG_NUMBER',
    UnknownPerson = 'UNKNOWN_PERSON',
    IdentityTheft = 'IDENTITY_THEFT',
    Spam = 'SPAM',
    Other = 'OTHER'
}

export function LeadClosedReasonEnumFromJSON(json: any): LeadClosedReasonEnum {
    return LeadClosedReasonEnumFromJSONTyped(json, false);
}

export function LeadClosedReasonEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadClosedReasonEnum {
    return json as LeadClosedReasonEnum;
}

export function LeadClosedReasonEnumToJSON(value?: LeadClosedReasonEnum | null): any {
    return value as any;
}

